import { NgClass } from '@angular/common';
import {
  booleanAttribute,
  Component,
  ElementRef,
  EventEmitter,
  HostListener,
  Input,
  Output,
  ViewChild
} from '@angular/core';
import { MatIconButton } from '@angular/material/button';
import { ThemePalette } from '@angular/material/core';
import { MatIcon } from '@angular/material/icon';
import { PermissionLockDirective } from '@app/shared/directives/permission-lock.directive';

@Component({
  selector: 'restricted-icon-button',
  templateUrl: './restricted-icon-button.component.html',
  styleUrls: ['./restricted-icon-button.component.scss'],
  imports: [
    NgClass,
    MatIconButton,
    MatIcon,
    PermissionLockDirective
  ],
  standalone: true
})
export class RestrictedIconButtonComponent {
  /*
  Optional colour parameter
   */
  @Input() public colour: ThemePalette = undefined;

  /*
  Optional colour parameter
   */
  @Input() public withWhiteBackground = false;
  /*
  To link with the underlying button's click event
   */
  @Output() public onClick = new EventEmitter<any>();

  /*
  Array of permission codes found in permissions.enum.ts
  to display the button
   */
  @Input() public permissions: any[] = [];
  /*
  Boolean expression of preconditions to enable the button
   */
  @Input({ transform: booleanAttribute }) public preconditions: boolean = true;

  /*
  Boolean expression of preconditions to disable the button
   */
  @Input() public disabled: boolean = false;

  /*
  Boolean expression of margins to add to button
   */
  @Input() public withMargins: boolean = false;

  /*
  The icon's font set, e.g. 'mdi' for a class-based @mdi/font icon, or 'material-symbols-outlined'/
  'material-icons' for a ligature-based icon.
   */
  @Input() public fontSet: string = 'mdi';

  /*
  The icon to display: an @mdi/font class name (e.g. 'mdi-pencil') when fontSet is 'mdi', or the
  ligature name (e.g. 'home_work') for a ligature-based fontSet.
   */
  @Input() public icon: string = '';

  /*
  Additional CSS classes to apply to the icon (e.g. a size modifier like 'sm').
   */
  @Input() public iconClass: string | string[] = '';

  /*
  An id, use in e2e test for select the button
   */
  @Input() public id: string = '';

  // If set to true, the icon color is changed to the accent color
  @Input() public highlighted: boolean = false;

  // Spin the icon
  @Input() public spin = false;

  @ViewChild('iconButton') public iconButton: ElementRef;

  protected get resolvedIconClass(): string[] {
    const classes = Array.isArray(this.iconClass) ? [...this.iconClass] : this.iconClass.split(' ').filter(Boolean);
    if (this.highlighted) {
      classes.push('highlighted');
    }
    if (this.spin) {
      classes.push('mdi-spin');
    }
    return classes;
  }

  public internalButtonClick(event: MouseEvent): void {
    if (this.preconditions) {
      this.onClick.emit(event);
    }
  }

  /**
   * add handler on native JS click event
   * stop propagation and force usage of onCLick custom event
   */
  @HostListener('click', ['$event'])
  public handleNativeClick(e: MouseEvent): void {
      e.preventDefault();
      e.stopPropagation();
  }

}
